import React from 'react';
import AdminLayout from '../components/AdminLayout';

const SettingsPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="p-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
          <p className="text-gray-600 mt-2">Configure pricing plans and system settings</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-500">Settings management coming soon...</p>
        </div>
      </div>
    </AdminLayout>
  );
};

export default SettingsPage;

